<header *ngIf = "!isQrForm&&!isLogin">
    <app-menu></app-menu>
</header>
<div class = "" [ngClass] = "isLogin ? 'bgImg': ''">
    <router-outlet></router-outlet>
    <app-loader></app-loader>
</div>
